<template>
    <div class="bg-white">
        <div class="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
            <div class="dark:bg-gray-700 bg-racing-stars-yellow rounded-lg shadow-xl overflow-hidden lg:grid lg:grid-cols-2 lg:gap-4">
                <div class="pt-10 pb-12 px-6 sm:pt-16 sm:px-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20 col-span-2">
                    <div class="lg:self-center">
                        <h2 class="text-3xl font-extrabold text-gray-800 sm:text-4xl dark:text-white">
                            <span class="block">Ready to dive in?</span>
                            <span class="block">Sign up today.</span>
                        </h2>
                        <p class="mt-4 text-lg leading-6 text-gray-800 dark:text-white">Make sure you're in with a chance of winning our daily and weekly prizes. The next race starts... <strong>{{ nextRace }}</strong></p>
                        <a href="#top" class="mt-8 bg-white border border-transparent rounded-md shadow px-5 py-3 inline-flex items-center text-base font-medium text-gray-800 hover:opacity-80 dark:bg-racing-stars-yellow dark:text-gray-800 dark:hover:opacity-80">Sign Up Today</a>
                    </div>
                </div>
                <!-- <div class="-mt-6 aspect-w-5 aspect-h-3 md:aspect-w-2 md:aspect-h-1">
                    <img class="translate-x-6 translate-y-6 rounded-md object-cover object-left-top sm:translate-x-16 lg:translate-y-20" :src="asset('images/dashboard.png')" alt="Racing Stars dashboard" />
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
	import { computed } from 'vue'
    import moment from 'moment'

	export default {
		props: {
			nextRaceStartTime: String,
		},

		setup(props) {

            const nextRace = computed(() => {
                return props.nextRaceStartTime ? moment(props.nextRaceStartTime).format('h:mm a') : 'Tomorrow'
            })

			return {
                nextRace,
			}
		}
	}
</script>
